// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_lu-0";
export var discountCodeInput = "_lu-1";